export default "/50f517735fec46580f19aae3e56e9fe21614ea75/decc719ac0c1523cc2040d71b927dcbc.svg";